import { render, staticRenderFns } from "./scoresc.vue?vue&type=template&id=e3a437de&"
import script from "./scoresc.vue?vue&type=script&lang=js&"
export * from "./scoresc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports